import type { client } from "@/utils/orpc.client";

type ListsItemsData = Awaited<ReturnType<typeof client.lists.getListsItems>>;

export function listsFromItemsData(data: ListsItemsData | undefined): ListsItemsData["lists"] {
  if (!data) return [];
  return data.lists;
}
